import Star from '@mui/icons-material/Star';
import { Box, Skeleton, useTheme } from '@mui/material';
import ReactAspectRatio from 'react-aspect-ratio';
import { ResizableCard } from '../resizable-card';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var LoadingRewardCard = function LoadingRewardCard() {
  var theme = useTheme();
  return /*#__PURE__*/_jsxs(ResizableCard, {
    "data-element": "ResizableCard",
    "data-component": "LoadingRewardCard",
    "data-source-file": "loading-card.tsx",
    children: [/*#__PURE__*/_jsx(ReactAspectRatio, {
      ratio: "3/2",
      style: {
        maxWidth: 'auto',
        margin: 'auto'
      },
      "data-element": "ReactAspectRatio",
      "data-component": "LoadingRewardCard",
      "data-source-file": "loading-card.tsx",
      children: /*#__PURE__*/_jsx(Skeleton, {
        variant: "rectangular",
        width: "100%",
        height: "100%",
        "data-element": "Skeleton",
        "data-component": "LoadingRewardCard",
        "data-source-file": "loading-card.tsx"
      })
    }), /*#__PURE__*/_jsxs(Box, {
      sx: {
        mx: 2,
        mt: 1,
        height: 140,
        display: 'flex',
        justifyContent: 'space-between'
      },
      "data-element": "Box",
      "data-source-file": "loading-card.tsx",
      children: [/*#__PURE__*/_jsxs(Box, {
        sx: {
          width: 1
        },
        "data-element": "Box",
        "data-source-file": "loading-card.tsx",
        children: [/*#__PURE__*/_jsx(Skeleton, {
          width: "15%",
          height: 12,
          "data-element": "Skeleton",
          "data-source-file": "loading-card.tsx"
        }), /*#__PURE__*/_jsx(Skeleton, {
          width: "65%",
          height: 28,
          "data-element": "Skeleton",
          "data-source-file": "loading-card.tsx"
        })]
      }), /*#__PURE__*/_jsx(Star, {
        sx: {
          width: function width(t) {
            return t.spacing(3.5);
          },
          height: function height(t) {
            return t.spacing(3.5);
          },
          mt: 1
        },
        htmlColor: theme.palette.action.disabledBackground,
        "data-element": "Star",
        "data-source-file": "loading-card.tsx"
      })]
    })]
  });
};

export default LoadingRewardCard;